export default "__VITE_ASSET__D2PgZ8l2__"